module.exports = __webpack_public_path__ + "static/media/Q11-3.997fbcd5.jpg";